// extracted by mini-css-extract-plugin
module.exports = {"separator":"nextButton-module--separator--R87Xe","text":"nextButton-module--text--2vjZl"};